export enum ProjectStatus {
  READY = 'READY',
  QUEUED = 'QUEUED',
  INGESTED = 'INGESTED',
  REVIEWED = 'REVIEWED',
  CLEANING = 'CLEANING',
  ERROR = 'ERROR',
  PROCESSING = 'PROCESSING',
  FORMAT_ERROR = 'FORMAT_ERROR',
  FILETYPEERROR = 'FILETYPEERROR',
  FILESIZEERROR = 'FILESIZEERROR',
  ADDING_DATA = 'ADDING_DATA',
  COMBINING = 'COMBINING'
}

export enum DATE_GROUP {
  DAYS = 'DAYS',
  WEEKS = 'WEEKS',
  MONTHS = 'MONTHS',
  QUARTERS = 'QUARTERS',
  YEARS = 'YEARS',
  DECADES = 'DECADES',
  CENTURIES = 'CENTURIES',
  DAYOFWEEK = 'DAYOFWEEK',
  MONTHOFYEAR = 'MONTHOFYEAR',
  WEEKOFYEAR = 'WEEKOFYEAR',
  DAYOFMONTH = 'DAYOFMONTH'
}

export const DATE_GROUP_DISPLAY = {
  [DATE_GROUP.DAYS]: 'Days',
  [DATE_GROUP.WEEKS]: 'Weeks',
  [DATE_GROUP.MONTHS]: 'Months',
  [DATE_GROUP.QUARTERS]: 'Quarters',
  [DATE_GROUP.YEARS]: 'Years',
  [DATE_GROUP.DECADES]: 'Decades',
  [DATE_GROUP.CENTURIES]: 'Centuries',
  [DATE_GROUP.DAYOFWEEK]: 'Day of Week',
  [DATE_GROUP.MONTHOFYEAR]: 'Month of Year',
  [DATE_GROUP.WEEKOFYEAR]: 'Week of Year',
  [DATE_GROUP.DAYOFMONTH]: 'Day of Month'
};

export enum DATE_TIME_GROUP {
  SECONDS = 'SECONDS',
  MINUTES = 'MINUTES',
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  WEEKS = 'WEEKS',
  MONTHS = 'MONTHS',
  QUARTERS = 'QUARTERS',
  YEARS = 'YEARS',
  DECADES = 'DECADES',
  CENTURIES = 'CENTURIES',
  DAYOFWEEK = 'DAYOFWEEK',
  MONTHOFYEAR = 'MONTHOFYEAR',
  WEEKOFYEAR = 'WEEKOFYEAR',
  DAYOFMONTH = 'DAYOFMONTH',
  HOUROFDAY = 'HOUROFDAY'
}

export const DATE_TIME_GROUP_DISPLAY = {
  [DATE_TIME_GROUP.DAYS]: 'Days',
  [DATE_TIME_GROUP.WEEKS]: 'Weeks',
  [DATE_TIME_GROUP.MONTHS]: 'Months',
  [DATE_TIME_GROUP.QUARTERS]: 'Quarters',
  [DATE_TIME_GROUP.YEARS]: 'Years',
  [DATE_TIME_GROUP.DECADES]: 'Decades',
  [DATE_TIME_GROUP.CENTURIES]: 'Centuries',
  [DATE_TIME_GROUP.DAYOFWEEK]: 'Day of Week',
  [DATE_TIME_GROUP.MONTHOFYEAR]: 'Month of Year',
  [DATE_TIME_GROUP.WEEKOFYEAR]: 'Week of Year',
  [DATE_TIME_GROUP.DAYOFMONTH]: 'Day of Month',
  [DATE_TIME_GROUP.HOUROFDAY]: 'Hour of Day'
};

export const DATE_GROUP_WITHOUT_FORMAT = [
  DATE_GROUP.DAYOFWEEK,
  DATE_GROUP.MONTHOFYEAR,
  DATE_GROUP.WEEKOFYEAR,
  DATE_GROUP.DAYOFMONTH,
  DATE_TIME_GROUP.HOUROFDAY,
  DATE_TIME_GROUP.DAYOFWEEK,
  DATE_TIME_GROUP.MONTHOFYEAR,
  DATE_TIME_GROUP.WEEKOFYEAR,
  DATE_TIME_GROUP.DAYOFMONTH
];

export enum DATE_HOUR_GROUP {
  HOURS = 'HOURS',
  DAYS = 'DAYS',
  WEEKS = 'WEEKS',
  MONTHS = 'MONTHS',
  QUARTERS = 'QUARTERS',
  YEARS = 'YEARS',
  DECADES = 'DECADES',
  CENTURIES = 'CENTURIES',
  DAYOFWEEK = 'DAYOFWEEK',
  MONTHOFYEAR = 'MONTHOFYEAR',
  WEEKOFYEAR = 'WEEKOFYEAR',
  DAYOFMONTH = 'DAYOFMONTH',
  HOUROFDAY = 'HOUROFDAY'
}

export enum ColumnTypes {
  TEXT = 'TEXT',
  NUMBER = 'NUMBER',
  CURRENCY = 'CURRENCY',
  DATE = 'DATE',
  DATETIME = 'DATETIME',
  TIME = 'TIME',
  BOOLEAN = 'BOOLEAN',
  EMAIL = 'EMAIL',
  GEO = 'GEO',
  LIST = 'LIST',
  EMPTY = 'EMPTY',
  URL = 'URL',
  ID = 'ID',
  PERCENTAGE = 'PERCENTAGE',
  ADDRESS = 'ADDRESS',
  SCALE = 'SCALE',
  OTHER = 'OTHER'
}

export enum StorageKeys {
  PREVIOUS_URL = 'prevUrl',
  VISITED_CHARTS = 'visited_charts'
}

export enum PageNames {
  MY_PROJECTS = 'My Projects',
  DELETED_PROJECTS = 'Deleted Projects',
  SIGN_IN = 'Sign In',
  SIGN_UP = 'Sign Up',
  PROJECT_REVIEW = 'Project Review',
  PROJECT_BOARD = 'Project Board',
  EDIT_CHART = 'Edit chart',
  ADD_CHART = 'Add chart',
  CHART_PREVIEW = 'Chart Preview',
  PROJECT_BOARD_PREVIEW = 'Project Board Preview'
}

export enum FeatureNames {
  MAX_MONTHLY_DATA_UPDATE_LIMIT = 'MAX_MONTHLY_DATA_UPDATE_LIMIT',
  MAX_MONTHLY_DATA_UPDATE_TRIAL_LIMIT = 'MAX_MONTHLY_DATA_UPDATE_TRIAL_LIMIT'
}

export const numberEquivalents = ['NUMBER', 'PERCENTAGE', 'SCALE', 'CURRENCY'];

export const textEquivalents = ['ID', 'URL', 'ADDRESS', 'EMAIL', 'TEXT'];

export const dateEquivalents = ['DATE', 'DATETIME'];

export const trialPeriodInDays = 3;

export const pbWithChartsId = 'pbWithChartsId';

export const dataTableTotalKeyword = 'GRAND TOTAL';

export enum FileTypes {
  GSHEET = 'GSHEET',
  CSV = 'CSV',
  EXCEL = 'EXCEL'
}

export enum FeatureTypes {
  DOWNLOAD_CLEANED_FILE = 'DOWNLOAD_CLEANED_FILE',
  COMBINE_APPEND_FILE = 'COMBINE_APPEND_FILE',
  MANUAL_UPDATE = 'MANUAL_UPDATE',
  SQUIRBY = 'SQUIRBY',
  AUTO_CATEGORIZATION = 'AUTO_CATEGORIZATION',
  REST_API = 'REST_API',
  DOWNLOAD_REPORTS = 'DOWNLOAD_REPORTS',
  PROJECT_INSIGHTS = 'PROJECT_INSIGHTS',
  CHART_INSIGHTS = 'CHART_INSIGHTS',
  REMOVE_WATERMARK = 'REMOVE_WATERMARK',
  AUTO_AI = 'AUTO_AI',
  MAX_MONTHLY_INSIGHTS_LIMIT = 'MAX_MONTHLY_INSIGHTS_LIMIT',
  MAX_MONTHLY_DATA_UPDATE_LIMIT = 'MAX_MONTHLY_DATA_UPDATE_LIMIT'
}
